import React from 'react';
import {SVGModel} from '../../../framework.visual/model/svgModel';

export const ArrowRightSVG = ({className} : SVGModel) => (
    <svg className={className} viewBox="0 0 32 32">
        <path d="M 8,16 V 0 l 8,8 8,8 -8,8 -8,8 z"/>
    </svg>
);


